import { createAction } from 'redux-actions'
import { SEND_TRANSACTION_STATUS } from '../consts/payment'

export const sendTransactionStatus = createAction(SEND_TRANSACTION_STATUS)
